import type { MethodContent } from ".";

export const METHOD_CONTENT: MethodContent[] = [
  {
    method: "Amazon",
    exchangeRange: "500-100,000円分",
    availableYenOptions: ["500", "1000", "5000", "10000"],
    description:
      "Amazon.co.jpで数億種類の商品購入に使用可能です。Amazonでの買い物だけでなく、Kindle本やAmazonプライム会費の支払いにも利用可能です。",
    iconSrc: "/assets/amazon-gift.svg",
    heading: "Amazonギフトカード",
  },
  {
    method: "Apple",
    exchangeRange: "1000-100,000円分",
    availableYenOptions: ["1000", "5000", "10000"],
    description:
      "Apple Gift Cardは、Appleのハードウェア、アクセサリ、App、ゲーム、音楽、映画、テレビ番組などの購入に利用できます。App内コンテンツ、ブックやサブスクリプション、iCloudのストレージも購入できます。",
    iconSrc: "/assets/apple-gift.svg",
    heading: "Apple Gift Card",
  },
  {
    method: "Google",
    exchangeRange: "500-100,000円分",
    availableYenOptions: ["500", "1000", "5000", "10000"],
    description:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。",
    iconSrc: "/assets/google-gift.svg",
    heading: "Google Playギフトカード",
  },
  {
    method: "AuPay",
    exchangeRange: "500-100,000円分",
    availableYenOptions: ["500", "1000", "5000", "10000"],
    description:
      "えらべるPayは、様々なスマホ決済サービスのポイントを自由にえらべるギフトです。スマホ決済サービスで利用できるポイントから、ECサイトで使えるギフトコードまで、幅広いラインナップを取り揃えています。",
    iconSrc: "/assets/aupay.svg",
    heading: "えらべるPay",
  },
  {
    method: "Giftee",
    exchangeRange: "500-100,000円分",
    availableYenOptions: ["500", "1000", "5000", "10000"],
    description:
      "giftee Box Selectは、170ブランド・約1,000種類のラインナップの中から、好きな商品を自由にえらべるギフトです。コンビニやカフェ、ファッション、レジャーまで幅広いシーンのギフトを取り揃えており、店頭やWEB上ですぐに利用ができます。",
    iconSrc: "/assets/giftee-box.svg",
    heading: "giftee Box Select",
  },
];
